import { Vue, Component, Prop, Watch, Inject } from "vue-property-decorator";
import style from "./style.vue";
import { morentupian } from "./iconMenu";
import { numberToArray, noop } from "@/util";
import { IPSService } from "@/services/ipsServices";
import periodicalLink from "@/views/components/linkForm/periodicalLink";

export enum qiKanShowWindowShowType {
	LINE = 1, // 一行2个
	SCROLL, // 横向滚动
	BIG, // 大图
}

export const qiKanShowWindowShowTypeImg = {
	[qiKanShowWindowShowType.LINE]: "https://ssl-picture.tenyun.runsasoft.com/c6586a30-807a-11ea-b75b-775d8e954200",
	[qiKanShowWindowShowType.BIG]: "https://ssl-picture.tenyun.runsasoft.com/ad49ecd0-807a-11ea-ac87-9ba7dcb3330b",
	[qiKanShowWindowShowType.SCROLL]: "https://ssl-picture.tenyun.runsasoft.com/bd4f07a0-807a-11ea-ac87-9ba7dcb3330b",
};

@Component({
	mixins: [style],
})
export default class QiKanShowWindow extends Vue {
	@Prop({ default: () => {} })
	value: ItemObject;

	@Prop({ default: false })
	disabled: boolean;

	@Inject({ default: 2 })
	mode: number;

	@Prop()
	sgId: number;

	@Prop()
	fromPage: number;

	data: ItemObject = {};

	flag: boolean;

	linkValue = {
		linkId: 0,
		linkType: 0,
		linkDesc: "",
	};

	showWindow = true;
	@Watch("value", { deep: true, immediate: true })
	watchValue(n, o) {
		if (JSON.stringify(n) !== JSON.stringify(o)) {
			this.data = n;
			if (this.data.desc.list !== []) {
				this.flag = true;
			}
		}
	}

	@Watch("data", { deep: true })
	watchData(n, o) {
		if (JSON.stringify(n) !== JSON.stringify(o)) {
			this.data = n;
		}
		this.$emit("input", this.data);
	}

	getWinArr(type): number[] {
		if (qiKanShowWindowShowType.LINE === type) {
			return numberToArray(5).map((i) => i * 2);
		} else {
			return numberToArray(10);
		}
	}

	onDelTab(i) {
		this.$confirm("是否删除该期刊?", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			closeOnClickModal: false,
			type: "warning",
		}).then((result) => {
			if (result === "confirm") {
				this.data.desc.list.splice(i, 1);
			}
		});
	}

	addQiKan(list) {
		if (this.data.desc.list.length < 10) {
			periodicalLink.open({ sgId: this.sgId, siteCodes: [this.$route.params.code], showwindow: this.showWindow }).then((result) => {
				if (result.length === 11) {
					this.$message.error("最多添加10个期刊！");
					return;
				}
				if (this.flag) {
					const arr = list.map((val) => val.linkList[0].linkId);
					for (const i of result) {
						if (arr.includes(i.qiKanId)) {
							this.$message.warning("选中期刊已存在！");
							return;
						}
						list.push({
							advPic: i.qiKanCover,
							linkList: [
								{
									linkId: i.qiKanId,
									linkDesc: `【期刊】${i.qiKanId}-${i.qiKanContent}`,
									linkType: 1,
								},
							],
						});
					}
				} else {
					for (const i of result) {
						list.push({
							advPic: i.qiKanCover,
							linkList: [
								{
									linkId: i.qiKanId,
									linkDesc: `【期刊】${i.qiKanId}-${i.qiKanContent}`,
									linkType: 1,
								},
							],
						});
					}
				}
			}, noop);
		} else {
			this.$message.error("最多添加10个期刊！");
		}
	}

	deleteAll(list) {
		this.$confirm("是否删除该期刊?", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			closeOnClickModal: false,
			type: "warning",
		}).then((result) => {
			if (result === "confirm") {
				list.splice(0, list.length);
			}
		});
	}

	changeRadio(val, list) {
		if (val === 2) {
			list.splice(0, list.length);
		}
	}

	render(h) {
		return (
			<div class="show-window" key={this.data._sort}>
				<div class="cont">
					<el-form props={{ model: this.data.desc }} ref="form" label-width="110px" label-position={"left"} disabled={this.disabled}>
						<p class="title">橱窗标题</p>
						<el-form-item label="标题" prop="qiKanName" rules={[{ required: true, message: " ", trigger: ["change", "blur"] }]}>
							<el-input v-model={this.data.desc.qiKanName} maxlength="8" />
						</el-form-item>
						<el-form-item label="大小">
							<el-radio-group v-model={this.data.desc.qiKanSize}>
								<el-radio label={28}>小</el-radio>
								<el-radio label={36}>中</el-radio>
								<el-radio label={44}>大</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="样式">
							<el-checkbox-group v-model={this.data.desc.style} style="display:flex">
								<el-checkbox label={"bold"}>加粗</el-checkbox>
								<el-checkbox label={"center"}>居中对齐</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<div class="bottom-nav-config">
							<p class="title">期刊展示方式</p>
						</div>
						<el-radio-group
							v-model={this.data.desc.qiKanStyle}
							class="radio-group window-select"
							onChange={(val) => {
								this.$nextTick(() => {
									switch (val) {
										case qiKanShowWindowShowType.LINE:
											this.data.desc.qiKanNum = 4;
											break;
										case qiKanShowWindowShowType.BIG:
											this.data.desc.qiKanNum = 3;
											break;
										case qiKanShowWindowShowType.SCROLL:
											this.data.desc.qiKanNum = 6;
											break;
									}
								});
							}}>
							<el-radio label={1}>一行两个</el-radio>
							<el-radio label={2}>横向滚动</el-radio>
							<el-radio label={3}>大图</el-radio>
						</el-radio-group>
						<div class="sketch-img">
							{Object.keys(qiKanShowWindowShowTypeImg).map((v, i) => {
								return (
									<img
										src={qiKanShowWindowShowTypeImg[v]}
										alt=""
										onClick={() => {
											this.data.desc.qiKanStyle = +v;
										}}
									/>
								);
							})}
						</div>
						<p class="font-size-14 r-mt-14 text-grey-17">
							橱窗显示期刊数量
							<el-select v-model={this.data.desc.qiKanNum} class="r-ml-14 wid-40">
								{this.getWinArr(this.data.desc.qiKanStyle).map((i) => {
									return (
										<el-option label={i} value={i}>
											{i}
										</el-option>
									);
								})}
							</el-select>
							个，剩余显示在更多画面
						</p>
					</el-form>
					<el-form props={{ model: this.data.desc }} disabled={this.disabled}>
						<p class="title r-mt-10">期刊管理</p>
						<el-form-item>
							<el-radio-group
								onChange={(val) => {
									this.changeRadio(val, this.data.desc.list);
								}}
								v-model={this.data.desc.qiKanType}>
								<el-radio label={1}>指定期刊</el-radio>
								<el-radio label={2}>最新期刊</el-radio>
							</el-radio-group>
							{this.data.desc.qiKanType === 1 && (
								<div>
									<p>
										<el-button type="primary" onClick={this.addQiKan.bind(this, this.data.desc.list)}>
											添加期刊
										</el-button>
										<span class="scopeSpan r-ml-20" onClick={this.deleteAll.bind(this, this.data.desc.list)}>
											重置
										</span>
									</p>
									<draggable v-model={this.data.desc.list}>
										{this.data.desc.list.length > 0 &&
											this.data.desc.list.map((val, i) => {
												return (
													<div class="qikan-nav-item">
														<img class="img-div" src={val.advPic || morentupian} />
														<el-tooltip class="item" effect="dark" content={val.linkList[0].linkDesc}>
															<span class="qikan-desc">{val.linkList[0].linkDesc}</span>
														</el-tooltip>
														<span class="absolute cursor-pointer inline-block right-6 text-blue-15" onClick={this.onDelTab.bind(this, i)}>
															X
														</span>
													</div>
												);
											})}
									</draggable>
									<p class="tip">
										<span class="redText">*&nbsp;</span>拖动可对期刊进行排序，最多可放置10个期刊
									</p>
								</div>
							)}
							{this.data.desc.qiKanType === 2 && (
								<p class="tip">
									<span class="redText">*&nbsp;</span>最多展示10个期刊
								</p>
							)}
						</el-form-item>
					</el-form>
				</div>
			</div>
		);
	}
}
